import React from 'react';
import { AttachmentCard } from '@/components/ui/AttachmentCard/AttachmentCard';
import { buildMessengerAttachmentCardTopHeader } from '@/components/Messenger/shared/attachments/MessengerAttachmentCardTopHeader';
import { formatFileSizeRuOptional } from '@/utils/formatFileSize';
import './MessengerDmFileAttachment.css';

export function MessengerDmFileAttachment({
  href,
  header,
  peerAuthorName,
  forwardedFromSenderName,
  replyQuote,
  fileName,
  fileSizeBytes,
  isOwn,
  attachmentPhase,
}: {
  href: string;
  /** Имя в текстовой колонке (когда шапка карточки не используется). */
  header?: string | null;
  peerAuthorName?: string | null;
  forwardedFromSenderName?: string | null;
  replyQuote?: React.ReactNode;
  fileName?: string | null;
  fileSizeBytes?: number | string | null;
  isOwn: boolean;
  attachmentPhase?: 'uploading' | 'posting';
}): React.ReactNode {
  const busy = Boolean(isOwn && attachmentPhase);
  const label =
    attachmentPhase === 'uploading'
      ? 'Загрузка файла'
      : attachmentPhase === 'posting'
        ? 'Отправка сообщения'
        : undefined;

  const sizeSubtitle = formatFileSizeRuOptional(fileSizeBytes) ?? undefined;

  const topHeader = buildMessengerAttachmentCardTopHeader({
    peerAuthorName,
    forwardedFromSenderName,
    replyQuote,
    isOwn,
  });

  return (
    <AttachmentCard
      variant="file"
      topHeader={topHeader}
      header={topHeader ? null : header}
      title={fileName || 'Файл'}
      subtitle={sizeSubtitle}
      href={href}
      busy={busy}
      busyLabel={label}
    />
  );
}
